// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RHSDx","content":"styles_content__Q9A7A","row":"styles_row__1mRcO","footer":"styles_footer__3Zf0h","phraseLength":"styles_phraseLength__3_WBf"};